import React, { lazy, Suspense } from 'react';

const LazySsidList = lazy(() => import('./SsidList'));

const SsidList = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazySsidList {...props} />
  </Suspense>
);

export default SsidList;
